import { render, staticRenderFns } from "./WorkLanguageSelector.vue?vue&type=template&id=3b3a2a5e&scoped=true&"
import script from "./WorkLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./WorkLanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a2a5e",
  null
  
)

/* custom blocks */
import block0 from "./WorkLanguageSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItemContent,VListItemSubtitle,VListItemTitle,VSelect})
